import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SendCommandDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
declare var $: any
@Component({
  selector: 'app-ring-device',
  templateUrl: './ring-device.component.html'
})
export class RingDeviceComponent implements OnInit {
  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl('')
  })
  SCAN_FROM_CLOUD: string = 'SCAN_FROM_CLOUD'
  constructor(private _router: Router, private _Service: ApiService,
    private activatedRoute: ActivatedRoute, private _toastr: ToastrService, private location: Location) { }
  isRing: boolean = false;
  deviceId: string = '';
  sendCommanddto: SendCommandDto = new SendCommandDto();
  isLoading: boolean = false;
  ngOnInit(): void {
    this.deviceId = this.activatedRoute.snapshot.params["id"];
    this.getDevicesInUser()
  }
  goBack() {
    this.location.back()
  }

  // Send Command
  errorMessage: string = ''
  sendCommand() {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = this.deviceId;
      this.sendCommanddto.requestType = 'RING'
      this._Service.postService(this._Service.API_URL.sendCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          $("#LockPopup").modal("show");

          this.isRing = false
          this._toastr.success('', response.status.message);
          setTimeout("$('#LockPopup').modal('hide');",1500);
        } else {
          this._toastr.error('', response.status.message);
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }
  mobileDevice: any[] = [];
  deviceName: any
  getDevicesInUser() {
    this.isLoading = true;
    try {
      this._Service.getService(this._Service.API_URL.getDevicesInUser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.mobileDevice = response.data;
          if (this.deviceId) {
            this.mobileDevice.forEach((element: any) => {
              if (this.deviceId == element.id) {
                this.deviceName = element.deviceName;
                this.restorePublishForm.controls['mobileDeviceName'].setValue(element.id);
              }
            });
          }
          else {
            let deviceId = response.data[0].id;
            this.restorePublishForm.controls['mobileDeviceName'].setValue(deviceId);
          }
        } else {
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  onMobileDeviceSelect(event: any) {
    this.deviceId = event.target.value;
    this.mobileDevice.forEach(element => {
      if (this.deviceId == element.id) {
        this.deviceName = element.name;
      }
    });
  }
}
